export const animationConfigSlide = (width, childrenCount) => {
    return [
        {
            width: '52%',
            zIndex: 1,
        },
        {
            width: '16%',
            zIndex: 1,
        },
        {
            width: '16%',
            zIndex: 1,
        },
        {
            width: '16%',
            zIndex: 1,
        },
    ]
};

/**
* Create the animation configs using the
* number of children in this panel
*/
export const animationConfigCarouselX1 = () => {
    return [
        {
            width: "100%",
            x: `${0}px`,
            zIndex: 1
        }
    ]
};

/**
* Create the animation configs using the width & the
* number of children in this panel
*/
export const animationConfigCarouselX3 = (width, childrenCount, isDesktop) => {
    return [
        {
            width: "63%",
            x: `-${width * 0.63 * 3}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "63%",
            x: `-${width * 0.63 * 2}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "63%",
            x: `-${width * 0.63}px`,
            zIndex: 0,
            opacity: 1
        },
        {
            width: "63%",
            x: `${0}px`,
            zIndex: 1,
            opacity: 1
        },
        {
            width: "31%",
            x: `${width * 0.63}px`,
            zIndex: 20,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 0.84}px`,
            zIndex: 21,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 1}px`,
            zIndex: 0,
            opacity: 1
        },
        {
            width: "26%",
            x: `${width * 1.16}px`,
            zIndex: 0,
            opacity: 0
        },
        {
            width: "26%",
            x: `${width * 1.32}px`,
            zIndex: 0,
            opacity: 0
        }
    ]
};

/**
* Create the animation configs using the width & the
* number of children in this panel
*/
export const animationConfigCarouselX2 = (width, childrenCount, isDesktop) => {
    return [
        {
            width: '80%',
            x: `-${width * 1.6}px`,
            zIndex: 1,
            opacity: 0
        },
        {
            width: '80%',
            x: `-${width * 0.8}px`,
            zIndex: 1,
            opacity: 1
        },
        {
            width: '80%',
            x: `${0}px`,
            zIndex: 20,
            opacity: 1
        },
        {
            width: "31%",
            x: `${width * 0.8}px`,
            zIndex: 21,
            opacity: 1
        },
        {
            width: "31%",
            x: `${width * 1}px`,
            zIndex: 1,
            opacity: 1
        },
        {
            width: "31%",
            x: `${width * 1.21}px`,
            zIndex: 1,
            opacity: 0
        }
    ]
};
